/**
 * Proven By Design — Mobile layout v2
 * Integrated result cards plus a mobile-only full-results drawer.
 */
(function () {
  if (window.__provenMobileV2Loaded) return;
  window.__provenMobileV2Loaded = true;

  var activeDrawer = null;
  var activeOpener = null;
  var savedBodyStyles = null;

  /* Keep JS cleanup in step with the drawer transition in proven-mobile-v2.css. */
  var DRAWER_FALLBACK_DURATION = 420;

  function getFocusableElements(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function lockPage() {
    if (savedBodyStyles) return;

    savedBodyStyles = {
      bodyOverflow: document.body.style.overflow,
      htmlOverflow: document.documentElement.style.overflow,
      scrollY: window.pageYOffset || document.documentElement.scrollTop || 0,
    };

    document.documentElement.classList.add('proven-mobile-drawer-open');
    document.body.classList.add('proven-mobile-drawer-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function unlockPage() {
    if (!savedBodyStyles) return;

    document.documentElement.classList.remove('proven-mobile-drawer-open');
    document.body.classList.remove('proven-mobile-drawer-open');
    document.documentElement.style.overflow = savedBodyStyles.htmlOverflow;
    document.body.style.overflow = savedBodyStyles.bodyOverflow;
    try {
      window.scrollTo({
        top: savedBodyStyles.scrollY,
        left: window.pageXOffset || 0,
        behavior: 'auto',
      });
    } catch (error) {
      window.scrollTo(0, savedBodyStyles.scrollY);
    }
    savedBodyStyles = null;
  }

  function getTransitionDuration(element) {
    if (!element || !window.getComputedStyle) return DRAWER_FALLBACK_DURATION;

    var styles = window.getComputedStyle(element);
    var durations = styles.transitionDuration.split(',');
    var delays = styles.transitionDelay.split(',');
    var longest = 0;

    durations.forEach(function (duration, index) {
      var durationValue = parseFloat(duration) || 0;
      var delayValue = parseFloat(delays[index] || delays[0] || 0) || 0;
      var durationMs = (duration.indexOf('ms') > -1 ? durationValue : durationValue * 1000) +
        (delays[index] && delays[index].indexOf('ms') > -1 ? delayValue : delayValue * 1000);
      longest = Math.max(longest, durationMs);
    });

    return longest;
  }

  function clearCloseAnimation(drawer) {
    if (!drawer) return;

    var panel = drawer.querySelector('.proven-mobile-drawer__panel');
    if (panel && drawer.__provenCloseHandler) {
      panel.removeEventListener('transitionend', drawer.__provenCloseHandler);
    }
    if (drawer.__provenCloseTimer) window.clearTimeout(drawer.__provenCloseTimer);
    drawer.__provenCloseHandler = null;
    drawer.__provenCloseTimer = null;
    drawer.removeAttribute('data-proven-closing');
  }

  function closeDrawer(restoreFocus) {
    if (!activeDrawer) return;

    var drawer = activeDrawer;
    var opener = activeOpener;
    if (drawer.getAttribute('data-proven-closing') === 'true') return;

    drawer.setAttribute('data-proven-closing', 'true');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (opener) opener.setAttribute('aria-expanded', 'false');

    if (!restoreFocus && drawer.contains(document.activeElement)) {
      document.activeElement.blur();
    }

    var panel = drawer.querySelector('.proven-mobile-drawer__panel');
    var finished = false;
    var finishClose = function (event) {
      /* Only the panel's transform marks the end of the drawer animation. */
      if (event && (event.target !== panel || event.propertyName !== 'transform')) return;
      if (finished) return;
      finished = true;
      clearCloseAnimation(drawer);

      var scrollY = savedBodyStyles ? savedBodyStyles.scrollY : null;
      var shouldRestoreFocus = restoreFocus !== false && opener && document.contains(opener);

      /* Focus while the page is still locked so WebKit cannot scroll the opener
         into view during the close hand-off. */
      if (shouldRestoreFocus) {
        try {
          opener.focus({ preventScroll: true });
        } catch (error) {
          opener.focus();
        }
      }

      if (activeDrawer === drawer) {
        activeDrawer = null;
        activeOpener = null;
        unlockPage();
      }

      /* Safari may perform one more layout pass after focus/overflow changes. */
      if (scrollY !== null) {
        window.requestAnimationFrame(function () {
          try {
            window.scrollTo({
              top: scrollY,
              left: window.pageXOffset || 0,
              behavior: 'auto',
            });
          } catch (error) {
            window.scrollTo(0, scrollY);
          }
        });
      }
    };

    drawer.__provenCloseHandler = finishClose;
    if (panel) panel.addEventListener('transitionend', finishClose);
    drawer.__provenCloseTimer = window.setTimeout(finishClose, getTransitionDuration(panel) + 80);
  }

  function openDrawer(drawer, opener) {
    if (!drawer || !window.matchMedia('(max-width: 767px)').matches) return;
    if (activeDrawer && activeDrawer !== drawer) closeDrawer(false);

    clearCloseAnimation(drawer);
    activeDrawer = drawer;
    activeOpener = opener;
    lockPage();
    drawer.setAttribute('aria-hidden', 'false');
    opener.setAttribute('aria-expanded', 'true');

    /* Force the closed position to be painted before starting the entrance. */
    drawer.classList.remove('is-open');
    void drawer.offsetWidth;

    window.requestAnimationFrame(function () {
      if (activeDrawer !== drawer) return;
      drawer.classList.add('is-open');
      var closeButton = drawer.querySelector('.proven-mobile-drawer__close');
      if (closeButton) closeButton.focus({ preventScroll: true });
    });
  }

  function initialiseSupportToggle(block) {
    if (block.dataset.provenSupportReady === 'true') return;

    var inner = block.querySelector('.effective-inner');
    var toggle = block.querySelector('[data-effective-toggle]');
    if (!inner || !toggle) return;

    var tags = inner.querySelectorAll('.txt-14');
    var extraCount = tags.length - 2;
    if (extraCount <= 0) return;

    block.dataset.provenSupportReady = 'true';
    tags.forEach(function (tag, index) {
      if (index >= 2) tag.classList.add('effective-tag--hidden');
    });

    toggle.textContent = '+' + extraCount + ' more';
    toggle.addEventListener('click', function () {
      var expanded = block.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded ? 'Show less' : '+' + extraCount + ' more';
    });
  }

  function initialiseResultSlider(resultBlock) {
    var swiperElement = resultBlock.querySelector('[data-proven-mobile-swiper]');
    var counter = resultBlock.querySelector('[data-proven-mobile-counter]');
    var pagination = resultBlock.querySelector('[data-proven-mobile-pagination]');
    if (!swiperElement || swiperElement.provenMobileSwiper) return;

    var slideCount = swiperElement.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
    if (slideCount <= 1) resultBlock.classList.add('is-single-result');

    function updateCounter(swiper) {
      if (!counter) return;
      counter.textContent = slideCount > 1 ? swiper.activeIndex + 1 + ' / ' + slideCount : '';
    }

    if (typeof window.Swiper !== 'function') {
      if (counter) counter.textContent = slideCount > 1 ? '1 / ' + slideCount : '';
      return;
    }

    var swiper = new window.Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 550,
      autoHeight: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      pagination: pagination
        ? {
            el: pagination,
            clickable: true,
          }
        : undefined,
      on: {
        init: updateCounter,
        slideChange: updateCounter,
      },
    });

    swiperElement.provenMobileSwiper = swiper;
    updateCounter(swiper);
  }

  function initialiseSection(section) {
    if (!section || section.dataset.provenMobileV2Ready === 'true') return;
    section.dataset.provenMobileV2Ready = 'true';

    var shopifySection = section.closest('.shopify-section');
    var ownerId = shopifySection ? shopifySection.id : 'proven-mobile-v2';

    section.querySelectorAll('[data-effective-support]').forEach(initialiseSupportToggle);
    section.querySelectorAll('[data-proven-mobile-results]').forEach(initialiseResultSlider);

    section.querySelectorAll('[data-proven-drawer-open]').forEach(function (opener) {
      opener.addEventListener('click', function () {
        openDrawer(document.getElementById(opener.getAttribute('data-proven-drawer-open')), opener);
      });
    });

    section.querySelectorAll('[data-proven-drawer]').forEach(function (drawer) {
      drawer.setAttribute('data-proven-owner', ownerId);
      document.body.appendChild(drawer);

      drawer.querySelectorAll('[data-proven-drawer-close]').forEach(function (closer) {
        closer.addEventListener('click', function (event) {
          closeDrawer(event.detail === 0);
        });
      });
    });

    section.querySelectorAll('.proven-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        window.requestAnimationFrame(function () {
          window.setTimeout(function () {
            section.querySelectorAll('[data-proven-mobile-swiper]').forEach(function (swiperElement) {
              if (swiperElement.provenMobileSwiper) swiperElement.provenMobileSwiper.update();
            });
          }, 20);
        });
      });
    });
  }

  function initProvenMobileV2(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('.proven-section--mobile-v2')) initialiseSection(scope);
    scope.querySelectorAll('.proven-section--mobile-v2').forEach(initialiseSection);
  }

  document.addEventListener('keydown', function (event) {
    if (!activeDrawer || activeDrawer.getAttribute('data-proven-closing') === 'true') return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer(true);
      return;
    }

    if (event.key !== 'Tab') return;
    var focusable = getFocusableElements(activeDrawer);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    initProvenMobileV2(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var ownerId = event.target && event.target.id;
    if (!ownerId) return;

    document.querySelectorAll('[data-proven-owner="' + ownerId + '"]').forEach(function (drawer) {
      if (drawer === activeDrawer) closeDrawer(false);
      drawer.remove();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProvenMobileV2(document);
    });
  } else {
    initProvenMobileV2(document);
  }

  window.addEventListener('load', function () {
    document.querySelectorAll('[data-proven-mobile-results]').forEach(initialiseResultSlider);
  });

  var mobileMedia = window.matchMedia('(max-width: 767px)');
  var handleViewportChange = function (event) {
    if (!event.matches && activeDrawer) closeDrawer(false);
  };
  if (typeof mobileMedia.addEventListener === 'function') {
    mobileMedia.addEventListener('change', handleViewportChange);
  } else if (typeof mobileMedia.addListener === 'function') {
    mobileMedia.addListener(handleViewportChange);
  }
})();
